export default __webpack_public_path__ + "static/media/imprimante.972e6566.png";